import React, { useState } from 'react';
import { Mail, User, Phone, MessageSquare, Send } from 'lucide-react';
import { toast } from 'sonner';
import { mockContactSubmit } from '../mock/data';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const serviceTypes = [
  'Avaliação de Imóveis',
  'Projeto Estrutural',
  'Projeto Arquitetônico',
  'Perícia Técnica',
  'Laudo de Vistoria',
  'Análise de Patologias',
  'Regularização de Imóveis',
  'Consultoria Técnica',
  'Outro'];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Por favor, preencha todos os campos obrigatórios');
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await mockContactSubmit(formData);
      if (result.success) {
        toast.success(result.message);
        setFormData({
          name: '',
          email: '',
          phone: '',
          serviceType: '',
          message: ''
        });
      }
    } catch (error) {
      toast.error('Erro ao enviar mensagem. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const whatsappNumber = "5535988192707";
  const whatsappMessage = "Olá! Gostaria de mais informações.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="contato" className="py-20 !bg-[#033530]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#033530] mb-4">
            Entre em Contato
          </h2>
          <p className="text-lg text-[#033530]/70">
            Estamos prontos para atender suas necessidades em engenharia e perícia técnica
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Form */}
          <div className="p-8 rounded-2xl shadow-lg !bg-[#F8F3E6]">
            <h3 className="text-2xl font-bold text-[#033530] mb-6">
              Envie sua Mensagem
            </h3>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name Field */}
              <div>
                <label htmlFor="name" className="block text-[#033530] font-medium mb-2">
                  Nome Completo *
                </label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#033530]/40" size={20} />
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border-2 border-transparent focus:border-[#ddc183] focus:outline-none transition-colors duration-200 pl-12 pr-4 py-3 rounded-lg text-[#033530] !bg-[#D6D2D2]"
                    placeholder="Seu nome"
                    required />

                </div>
              </div>

              {/* Email Field */}
              <div>
                <label htmlFor="email" className="block text-[#033530] font-medium mb-2">
                  E-mail *
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#033530]/40" size={20} />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border-2 border-transparent focus:border-[#ddc183] focus:outline-none transition-colors duration-200 pl-12 pr-4 py-3 rounded-lg text-[#033530] !bg-[#D6D2D2]"
                    placeholder="seu@email.com"
                    required />

                </div>
              </div>

              {/* Phone Field */}
              <div>
                <label htmlFor="phone" className="block text-[#033530] font-medium mb-2">
                  Telefone
                </label>
                <div className="relative">
                  <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#033530]/40" size={20} />
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full border-2 border-transparent focus:border-[#ddc183] focus:outline-none transition-colors duration-200 pl-12 pr-4 py-3 rounded-lg text-[#033530] !bg-[#D6D2D2]"
                    placeholder="(00) 00000-0000" />

                </div>
              </div>

              {/* Service Type Field */}
              <div>
                <label htmlFor="serviceType" className="block text-[#033530] font-medium mb-2">
                  Tipo de Serviço
                </label>
                <select
                  id="serviceType"
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleChange}
                  className="w-full border-2 border-transparent focus:border-[#ddc183] focus:outline-none transition-colors duration-200 px-4 py-3 rounded-lg text-[#033530] !bg-[#D6D2D2]">

                  <option value="">Selecione o serviço</option>
                  {serviceTypes.map((service, index) =>
                  <option key={index} value={service}>
                      {service}
                    </option>
                  )}
                </select>
              </div>

              {/* Message Field */}
              <div>
                <label htmlFor="message" className="block text-[#033530] font-medium mb-2">
                  Mensagem *
                </label>
                <div className="relative">
                  <MessageSquare className="absolute left-3 top-3 text-[#033530]/40" size={20} />
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    className="w-full border-2 border-transparent focus:border-[#ddc183] focus:outline-none transition-colors duration-200 resize-none pl-12 pr-4 py-3 rounded-lg text-[#033530] !bg-[#D6D2D2]"
                    placeholder="Descreva seu projeto ou necessidade..."
                    required />

                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#033530] text-[#e8d6b2] py-4 rounded-lg hover:bg-[#044a44] transition-colors duration-300 font-bold text-base flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">

                {isSubmitting ?
                <>Enviando...</> :

                <>
                    <Send size={20} />
                    Enviar Mensagem
                  </>
                }
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            {/* WhatsApp Card */}
            <div className="p-8 rounded-2xl shadow-lg !bg-[#F8F3E6]">
              <h3 className="text-2xl font-bold mb-4 !text-[#033530]">
                Atendimento Rápido
              </h3>
              <p className="mb-6 !text-[#033530]">Entre em contato direto pelo WhatsApp.

              </p>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center hover:bg-[#c9af71] transition-colors duration-300 hover:scale-105 transform transition-transform font-bold gap-3 px-6 py-4 rounded-lg !shadow-xl text-[#033530] !bg-[#F0E3C8]">

                <Phone size={24} />
                <div>
                  <div className="text-sm opacity-80">WhatsApp</div>
                  <div className="text-lg">+55 35 98819-2707</div>
                </div>
              </a>
            </div>

            {/* Office Hours */}
            <div className="p-8 rounded-2xl shadow-lg !bg-[#F8F3E6]">
              <h3 className="text-xl font-bold text-[#033530] mb-4">
                Horário de Atendimento
              </h3>
              <div className="space-y-3 text-[#033530]/80">
                <div className="flex justify-between">
                  <span>Segunda - Sexta</span>
                  <span className="font-medium">08:00 - 18:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Sábado</span>
                  <span className="font-medium">08:00 - 12:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Domingo</span>
                  <span className="font-medium">Fechado</span>
                </div>
              </div>
            </div>

            {/* Info Box */}
            <div className="border-2 border-[#ddc183]/30 p-8 rounded-2xl !bg-[#F8F3E6]">
              <h3 className="text-xl font-bold text-[#033530] mb-4">
                Resposta Garantida
              </h3>
              <p className="text-[#033530]/80 leading-relaxed">
                Respondemos todas as solicitações em até 24 horas úteis. Sua demanda é nossa prioridade.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default Contact;